import { getAddresses } from './getAddresses';
import { postAddress } from './postAddress';
import { putAddress } from './putAddress';
import { deleteAddress } from './deleteAddress';
import { changeDefaultAddress } from './changeDefaultAddress';

/**
 * - 배송지 관리 API
 * - iOS `AddressClient` / Android `AddressAPI` 와 동일 엔드포인트
 */
export const addressService = {
  getAddresses,
  postAddress,
  putAddress,
  deleteAddress,
  changeDefaultAddress,
};
